import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getDisabledDataAttribute } from '../utils/data-attribute/getDisabledDataAttribute.mjs';
import { primitiveButton, primitiveButtonClickableVariants } from './primitiveButton.vanilla.mjs';

const PrimitiveButtonImpl = forwardRef(
  ({
    className: classNameFromProps,
    clickableStyle = "default",
    disabled,
    ...props
  }, forwardedRef) => {
    const restrictedClickableStyle = typeof clickableStyle === "string" ? clickableStyle : "default";
    const className = classNames(
      primitiveButton,
      primitiveButtonClickableVariants[restrictedClickableStyle],
      classNameFromProps
    );
    return /* @__PURE__ */ jsx(
      Primitive.button,
      {
        type: "button",
        className,
        disabled,
        ...getDisabledDataAttribute(disabled),
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const PrimitiveButton = styled(PrimitiveButtonImpl);
PrimitiveButton.displayName = "PrimitiveButton";

export { PrimitiveButton };
//# sourceMappingURL=PrimitiveButton.mjs.map
